export const addSaleApi1 = (data) => ({ type: "GET_SALEAPI1", payload: data });
export const removeSaleApi1 = () => ({ type: "REMOVE_SALEAPI1" });

export const addSaleApi2 = (data) => ({ type: "GET_SALEAPI2", payload: data });
export const removeSaleApi2 = () => ({ type: "REMOVE_SALEAPI2" });

export const addSaleApi3 = (data) => ({ type: "GET_SALEAPI3", payload: data });
export const removeSaleApi3 = () => ({ type: "REMOVE_SALEAPI3" });

export const addSaleApi4 = (data) => ({ type: "GET_SALEAPI4", payload: data });
export const removeSaleApi4 = () => ({ type: "REMOVE_SALEAPI4" });

export const addSaleApi5 = (data) => ({ type: "GET_SALEAPI5", payload: data });
export const removeSaleApi5 = () => ({ type: "REMOVE_SALEAPI5" });

export const addSaleApi6b = (data) => ({ type: "GET_SALEAPI6B", payload: data });
export const removeSaleApi6b = () => ({ type: "REMOVE_SALEAPI6B" });

export const addSaleApi8 = (data) => ({ type: "GET_SALEAPI8", payload: data });
export const removeSaleApi8 = () => ({ type: "REMOVE_SALEAPI8" });

export const addSaleApi10 = (data) => ({ type: "GET_SALEAPI10", payload: data });
export const removeSaleApi10 = () => ({ type: "REMOVE_SALEAPI10" });

export const addSaleApi14 = (data) => ({ type: "GET_SALEAPI14", payload: data });
export const removeSaleApi14 = () => ({ type: "REMOVE_SALEAPI14" });

export const addSaleApi15 = (data) => ({ type: "GET_SALEAPI15", payload: data });
export const removeSaleApi15 = () => ({ type: "REMOVE_SALEAPI15" });

export const addSaleApi20 = (data) => ({ type: "GET_SALEAPI20", payload: data });
export const removeSaleApi20 = () => ({ type: "REMOVE_SALEAPI20" });

export const addSaleApi21a = (userType, data) => ({ type: "GET_SALEAPI20a", userType, payload: data });
export const removeSaleApi21a = () => ({ type: "REMOVE_SALEAPI20a" });

export const setSaleParentData = (userId, data) => ({
    type: "SET_SALE_PARENT_DATA",
    userId,
    payload: data,
});

export const setSaleChildData = (userId, data) => ({
    type: "SET_SALE_CHILD_DATA",
    userId,
    payload: data,
});











export const addTabSale10 = payload => ({
    type: 'GET_TAB10_SALE',
    payload
})
export const removeTabSale10 = payload => ({
    type: 'REMOVE_TAB10_SALE',
    payload
})

export const addTabSale11 = payload => ({
    type: 'GET_TAB11_SALE',
    payload
})
export const removeTabSale11 = payload => ({
    type: 'REMOVE_TAB11_SALE',
    payload
})
export const addTabSale5 = payload => ({
    type: 'GET_TAB5_SALE',
    payload
})
export const removeTabSale5 = payload => ({
    type: 'REMOVE_TAB5_SALE',
    payload
})

export const addTabSale6 = payload => ({
    type: 'GET_TAB6_SALE',
    payload
})
export const removeTabSale6 = payload => ({
    type: 'REMOVE_TAB6_SALE',
    payload
})

export const addTabSale7 = payload => ({
    type: 'GET_TAB7_SALE',
    payload
})
export const removeTabSale7 = payload => ({
    type: 'REMOVE_TAB7_SALE',
    payload
})
export const addTabSale8 = payload => ({
    type: 'GET_TAB8_SALE',
    payload
})
export const removeTabSale8 = payload => ({
    type: 'REMOVE_TAB8_SALE',
    payload
})

export const addTabSale9 = payload => ({
    type: 'GET_TAB9_SALE',
    payload
})
export const removeTabSale9 = payload => ({
    type: 'REMOVE_TAB9_SALE',
    payload
})